import {
    Modal,
    ModalContent,
    ModalOverlay,
    ModalBody,
    Button,
    ButtonGroup,
    ModalFooter,
    ModalHeader,
    ModalCloseButton,
    Text,
    Avatar,
    Flex,
    Heading
} from '@chakra-ui/react'
import { ChildrenService } from '@/shared/api/rest/services/children.service'
import { useAlertService } from '@/shared/lib/useAlertService'

function DeleteChildModal({ id, isOpen, onClose, fullName, picture }: any) {
    const alertService = useAlertService()

    async function onDeleteChild() {
        try {
            await ChildrenService.remove(id)
            alertService.success('Child deleted successfully')
            onClose()
            window.location.reload()
        } catch (error: any) {
            alertService.error(error.message, error.name)
        }
    }

    return (
        <Flex>
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                motionPreset="slideInBottom"
                scrollBehavior="inside"
            >
                <ModalOverlay backdropFilter="blur(8px)" />
                <ModalContent mx={'10px'} mt={'20vh'}>
                    <ModalHeader></ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Flex
                            justifyContent={'center'}
                            alignItems={'center'}
                            flexDirection={'column'}
                            gap={4}
                        >
                            <Avatar
                                bg={'brand.50'}
                                size={'xl'}
                                name={fullName}
                                src={picture}
                            />
                            <Heading size={['sm', 'md']}>Confirm delete</Heading>
                            <Text m={4} textAlign={'center'}>
                                You about to delete{' '}
                                <span
                                    style={{
                                        color: 'red',
                                        textDecoration: 'underline',
                                        fontWeight: 'bold'
                                    }}
                                >
                                    {fullName}
                                </span>{' '}
                                profile permanently. <br /> This action is irreversible.
                            </Text>
                        </Flex>
                    </ModalBody>

                    <ModalFooter mb={'20px'} justifyContent={'center'}>
                        <ButtonGroup gap={4}>
                            <Button variant={'outline'} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button colorScheme="red" onClick={onDeleteChild}>
                                Yes, Delete
                            </Button>
                        </ButtonGroup>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </Flex>
    )
}

export default DeleteChildModal
